import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PackageSearch, History, Settings, LogOut, Boxes, Receipt, Truck, TrendingUp, Users } from "lucide-react";

const nav = [
  { to: "/", label: "Verificare", icon: Receipt, end: true, id: "nav-verify" },
  { to: "/incasari", label: "Încasări pe dată", icon: TrendingUp, id: "nav-incasari" },
  { to: "/status-awb", label: "Status AWB-uri", icon: Truck, id: "nav-awb-status" },
  { to: "/verificare-completa", label: "Verificare cu AWB", icon: PackageSearch, id: "nav-full" },
  { to: "/istoric", label: "Istoric", icon: History, id: "nav-history" },
  { to: "/admin/utilizatori", label: "Utilizatori", icon: Users, id: "nav-admin-users", adminOnly: true },
  { to: "/setari", label: "Setări", icon: Settings, id: "nav-settings" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="w-60 shrink-0 border-r border-border flex flex-col bg-[#0c0c0e] sticky top-0 h-screen">
        <div className="px-5 h-16 flex items-center gap-2.5 border-b border-border">
          <div className="h-8 w-8 rounded-sm bg-primary flex items-center justify-center">
            <Boxes size={18} className="text-primary-foreground" />
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-tight">AWB Verifier</div>
            <div className="text-[10px] text-muted-foreground font-mono">CARGUS · v1</div>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {nav.filter((n) => !n.adminOnly || user?.role === "admin").map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.id}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-primary text-primary-foreground font-medium"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                }`
              }
            >
              <n.icon size={17} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 mb-1">
            <div className="text-xs font-mono truncate text-foreground">{user?.email}</div>
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider">{user?.role}</div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm text-muted-foreground hover:bg-[#FF3B30]/10 hover:text-[#FF3B30] transition-colors"
          >
            <LogOut size={17} />
            Deconectare
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}
